import { normalizeMediaUrl } from './normalizeMediaUrl';

const PREVIEW_FILE_PATTERN = /\.(pdf|jpe?g|png)($|\?|#)/i;

export function isImagePreviewUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  return /\.(jpe?g|png)($|\?|#)/i.test(url);
}

export function isImagePreviewContent(html: string | null | undefined): boolean {
  if (!html) {
    return false;
  }
  const fileNameMatch = html.match(/Arquivo enviado pelo cidadão:\s*([^<\n]+)/i);
  if (fileNameMatch?.[1] && /\.(jpe?g|png)$/i.test(fileNameMatch[1].trim())) {
    return true;
  }
  return /<img[^>]*\ssrc=/i.test(html);
}

export function extractFilePreviewUrl(
  html: string | undefined | null,
): string | null {
  if (!html) {
    return null;
  }

  const iframeMatch = html.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
  if (iframeMatch?.[1]) {
    return normalizeMediaUrl(iframeMatch[1]);
  }

  const imageRegex = /<img[^>]*\ssrc=["']([^"']+)["']/gi;
  let imageMatch = imageRegex.exec(html);
  while (imageMatch) {
    const src = imageMatch[1];
    if (!/qrserver\.com/i.test(src)) {
      return normalizeMediaUrl(src);
    }
    imageMatch = imageRegex.exec(html);
  }

  const linkRegex = /<a[^>]+href=["']([^"']+)["'][^>]*>/gi;
  let linkMatch = linkRegex.exec(html);
  while (linkMatch) {
    const href = linkMatch[1];
    if (PREVIEW_FILE_PATTERN.test(href) || /\/uploads\//i.test(href)) {
      return normalizeMediaUrl(href);
    }
    linkMatch = linkRegex.exec(html);
  }

  const plainUrlMatch = html.match(
    /(https?:\/\/[^\s"'<>]+\.(?:pdf|jpe?g|png)[^\s"'<>]*)/i,
  );
  if (plainUrlMatch?.[1]) {
    return normalizeMediaUrl(plainUrlMatch[1]);
  }

  return null;
}

export function buildGoogleGviewEmbedUrl(fileUrl: string): string {
  return `https://docs.google.com/gview?url=${encodeURIComponent(fileUrl)}&embedded=true`;
}

export function shouldUseLocalBlobPreview(
  fileUrl: string | null | undefined,
): boolean {
  // Blob preview é o padrão em qualquer ambiente: garante que a busca do
  // arquivo usa os headers de autenticação da própria app (Authorization),
  // ao contrário do Google Docs Viewer, que busca a URL sem token e sem
  // acesso a rede restrita (VPN/allowlist de hom/prod).
  return Boolean(fileUrl);
}
